export default __webpack_public_path__ + "static/media/kitchen3-afterG-2048w.33a0dd80.png";